/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from './../request.js'

export function accountList(params){
    return request({
        url: '/system/cardOperator/getAccountListByAgent.do?',
        method: 'post',
        data:params
    })
}

export function recordList(params){
    return request({
        url: 'card/phonebindrecord/list.do?',
        method: 'post',
        data:params
    })
}

export function deleteById(params){
    return request({
        url: 'card/phonebindrecord/deleteById.do?',
        method: 'post',
        data:params
    })
}

export function importBindCard(params){ //批量导入
    return request({
        url: 'card/phonebindrecord/importBindCardSync.do?',
        method: 'post',
        data:params,
        timeout:20000,
		headers:{'Content-Type': 'multipart/form-data'}
    })
}
export function importDeleteCard(params){  //批量删除
    return request({
        url: 'card/phonebindrecord/importDeleteCardSync.do?',
        method: 'post',
        data:params,
        timeout:20000,
		headers:{'Content-Type': 'multipart/form-data'}
    })
}
export function exportTOCListSync(params){
    return request({
        url: 'card/phonebindrecord/exportTOCListSync.do?',
        method: 'post',
        data:params
    })
}
